import { useQuery } from "@apollo/client";
import { FeedPost } from "@/__generated__/types";
import { FEED_POST_QUERY } from "@/api/queries/feedPost";

export const useFeedPost = (feedPostId?: string) => {
  const { data, loading, error } = useQuery(FEED_POST_QUERY, {
    variables: { id: feedPostId || "" },
    skip: !feedPostId,
  });

  const feedPost = data?.node?.__typename === "FeedPost" ? data.node : null;

  return {
    feedPost: feedPost as FeedPost | null,
    loading,
    error,
  };
};
